module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "loading-container",
    class: {
      'mini': _vm.mini, 'alt': _vm.alt, 'inline': _vm.inline, 'relative': _vm.relative
    }
  }, [_c('span', {
    staticClass: "loader-spinner"
  }, [_vm._v("Laden...")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-359b22d6","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Loading.vue
// module id = yJP+
// module chunks = 0 1